// extracted by mini-css-extract-plugin
export default {"root":"Dashboard_root__AMiNg","subTitle":"Dashboard_subTitle__2CsyM","title":"Dashboard_title__AGYZZ","progress":"Dashboard_progress__n5aXX","ideation":"Dashboard_ideation__hJiaR"};